import i18n from "@/i18n";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import queryString from "query-string";
import type { RootState } from "./store";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const { token, tenant } = state.auth;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      } else {
        throw new Error("Authorization token is missing");
      }
      if (tenant?.id) {
        headers.set("x-tenant-id", tenant.id);
      }
      if (i18n.resolvedLanguage) {
        headers.set("Accept-Language", i18n.resolvedLanguage);
      }
      return headers;
    },
    paramsSerializer: (params: Record<string, unknown>) => queryString.stringify(params, { arrayFormat: "none" }),
  }),
  endpoints: () => ({
    // mandatory field, leaving empty as will be populated by generatedApi
  }),
});
